export default "__VITE_ASSET__CwX9xcak__"